import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  name: {
    id: 'manage-services.integrated-service-detail.name',
    defaultMessage: 'Name',
  },
  description: {
    id: 'manage-services.integrated-service-detail.description',
    defaultMessage: 'Description',
  },
  duration: {
    id: 'manage-services.integrated-service-detail.duration',
    defaultMessage: 'Duration',
  },
  durationValue: {
    id: 'manage-services.integrated-service-detail.duration-value',
    defaultMessage: '{duration, number} min',
  },
  submitForReview: {
    id: 'manage-services.integrated-service-detail.submit-for-review',
    defaultMessage: 'Submit for review',
  },
  pricingSubmitted: {
    id: 'manage-services.integrated-service-detail.pricing-submitted',
    defaultMessage: 'Your pricing has been submitted for review.',
  },
});
